import { gql } from '@apollo/client';

import { studentFragment } from '../fragments';

export default gql`
  mutation AddStudentToCourse(
    $courseId: String!
    $input: AddStudentToCourseInput!
  ) {
    student(courseId: $courseId, input: $input)
      @rest(
        type: "Student"
        path: "courses/{args.courseId}/students"
        method: "POST"
      ) {
      ...Student
    }
  }
  ${studentFragment}
`;
